<div class="page-container">
  <fc-map-control
    class="map-overlay"
    [approvalRequired]="approvalRequired"
    [currentUser]="currentUser"
    [activeSite]="site"
    [readOnlyMap]="readOnlyMap"
    [drawer]="drawer"
    [currentStands]="currentStands"
    [showParcelTip]="showZoomInNote"
    (generateMap)="generateMap.emit()"></fc-map-control>
  <div #map class="map match-parent" id="forest-map" [ngClass]="currentMapStyle">
    <div *ngIf="showZoomInNote" class="zoom-in">
      <div class="header">Zoom In To See Forest Layer</div>
      <div class="message">Use the plus icon to the left to get closer</div>
    </div>
    <div class="legend">
      <div class="included-parcels">Included Parcel</div>
      <div class="included-stands">Included Stand</div>
      <div class="possible-forests">Eligible Forests</div>
      <div class="map-location">
        Map Center:
        <br />
        {{ currentLat }}, {{ currentLong }}
      </div>
    </div>
    <div class="disclaimer">
      Satellite images may differ from current up-to-date forest layer. The forest layer is used for all site
      calculations.
    </div>
  </div>
</div>
